import Vue from 'vue'
import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators'

@Module({
  namespaced: true
})
export default class SubscriptionStore extends VuexModule {
  appModulesLoaded = false
  appModules: KwixeoSubscriptions.Modules = []

  // CLEAR STORE STATE
  @Action
  clearStore (): void {
    const elements = ['AppModules']
    elements.forEach(key => {
      this.context.commit('set' + key, [])
      this.context.commit('set' + key + 'Loaded', false)
    })
  }

  // Sort a list alphabetically
  @Mutation
  orderList (param: { list: KwixeoInterface.GenericObject[]; key: string }): void {
    const key = param.key
    param.list.sort((a, b) => {
      const aKey = a[key].toLowerCase()
      const bKey = b[key].toLowerCase()
      if (aKey < bKey) return -1
      else if (aKey > bKey) return 1
      else return 0
    })
  }

  // Change the loaded state
  @Mutation
  setAppModulesLoaded (state = true): void {
    this.appModulesLoaded = state
  }

  // Set the app modules
  @Mutation
  setAppModules (modules: KwixeoSubscriptions.Modules): void {
    this.appModules = modules
  }

  // Add or update an app modules
  @Mutation
  updateModule (module: KwixeoSubscriptions.Module): void {
    if (!this.appModulesLoaded) {
      return
    }
    const index = this.appModules.findIndex(val => val.key === module.key)
    if (index >= 0) {
      Vue.set(this.appModules, index, module)
    } else {
      this.appModules.push(module)
    }
  }

  // Load the app modules from api
  @Action
  async loadAppModules (force = false): Promise<void> {
    if (!this.appModulesLoaded || force) {
      const response = await Vue.prototype.$kwSubscriptions.axios.get('/app/module')
      await this.context.commit('setAppModules', response.data)
      this.context.commit('setAppModulesLoaded')
    }
  }

  // Add or update an app modules
  @Action
  setModule (module: KwixeoSubscriptions.Module): void {
    this.context.commit('updateModule', module)
    if (this.appModulesLoaded) {
      this.context.commit('orderList', { list: this.appModules, key: 'name' })
    }
  }

  // Add or update team module datas
  @Action
  setTeamModule (module: KwixeoSubscriptions.Module): void {
    const value = this.appModules.find(value => value.key === module.key)
    if (value) {
      this.context.dispatch('setModule', Object.assign(value, module))

      const team = JSON.parse(JSON.stringify(this.context.rootGetters['user/team'])) as KwixeoFramework.Team
      if (team.app_modules) {
        const index = team.app_modules.findIndex(value => value.key === module.key)
        if (index >= 0) {
          team.app_modules[index] = module
        } else {
          team.app_modules.push(module)
        }
      }
      this.context.dispatch('user/setTeam', team, { root: true })
    }
  }

  // Check if a module is activated
  get hasModule (): (key: string) => boolean {
    return key => {
      const modules = this.context.rootGetters['user/team'].app_modules as KwixeoSubscriptions.Modules
      return modules.findIndex((module: KwixeoSubscriptions.Module) => module.key === key && module.active) !== -1
    }
  }
}
